import React, { Component } from 'react';
import { Button } from 'react-bootstrap';

export default class OperativeApproachToggleComponent extends Component {
    
	render() {
		const { operativeApproach, onChange } = this.props;

		return (
			<div className="d-flex justify-content-center">
				<Button
					variant={operativeApproach === "all" ? "custom-success" : "custom-outline-success"}
					className="me-2 custom-tsa-button"
					onClick={() => onChange("all")}
				>
					All
				</Button>
				<Button
					variant={operativeApproach === "anatomic" ? "custom-success" : "custom-outline-success"}
					className="me-2 custom-tsa-button"
					onClick={() => onChange("anatomic")}
				>
					Anatomic
				</Button>
				<Button
					variant={operativeApproach === "reverse" ? "custom-success" : "custom-outline-success"}
					className="custom-tsa-button"
					onClick={() => onChange("reverse")}
				>
					Reverse
				</Button>
            </div>
    
		);
	}
}
